import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, locationsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, locationsActions);

export default slice.reducer;
